import React, { Component } from 'react';
import { Card, Divider } from 'antd';
import { ComposableMap, Geographies, Geography } from 'react-simple-maps';
import { buildOptions } from './../../utils/survey';
import ReactTooltip from 'react-tooltip';
import { injectIntl } from 'react-intl';
import messages from './messages';
import chroma from 'chroma-js';
import geographyData from '../../assets/static/world-50m.json';
import ResultTotalAnswers from '../ResultTotalAnswers';
import ResultTitle from '../ResultTitle';
import { VictoryLegend } from 'victory';

const wrapperStyles = {
	width: '100%',
	maxWidth: 980,
	margin: '0 auto',
};

const colorScale = chroma.scale(['00BFFF', '000080']).domain([0, 100]);

const getColor = (geography, percentCountries) => {
	const countryCode = geography.properties.iso_a2;
	if (percentCountries[countryCode]) {
		return colorScale(percentCountries[countryCode]);
	}
	return chroma('#DCDCDC');
};


const buildPercentOptions = (options) => {
	let percentOptions = {};
	let optionsArray = Object.entries(options);
	
	optionsArray.sort(function(prev, next) {
		return prev[1] - next[1];
	}).forEach((el) => {
		let optionAmount = Math.ceil(el[1] / optionsArray[optionsArray.length - 1][1] * 100);
		let optionKey = el[0];
		percentOptions[optionKey] = optionAmount;
	});
	return percentOptions;
};

class ResultCountryMap extends Component{

	componentDidMount() {
		setTimeout(() => {
			ReactTooltip.rebuild();
		}, 100);
	}
	
	render() {
		const { questions, id, stepAnswers, intl: { formatMessage } } = this.props;
		const answerValues = Object.values(stepAnswers);
		const options = buildOptions(answerValues);
		
		return (
			<Card className='Result'>
				<div className='Answer'>
					<ResultTitle questions={questions} id={id}/>
					<ResultTotalAnswers stepAnswers={stepAnswers}/>
				</div>
				<Divider/>
				<div className='Answer' style={wrapperStyles}>
					<ComposableMap
						projectionConfig={{
							scale: 205,
							rotation: [-11, 0, 0],
						}}
						width={980}
						height={650}
						style={{
							width: '100%',
							height: 'auto',
						}}
					>
						<Geographies geography={geographyData}>
							{(geographies, projection) =>
								geographies.map((geography, i) => {
									const percentCountries = buildPercentOptions(options);
									const countryCode = geography.properties.iso_a2;
									const percent = percentCountries[countryCode] ? `, ${percentCountries[countryCode]}%` : '';
									return (geography.id !== 'ATA' &&
										<Geography
											key={i}
											data-tip={`${geography.properties.name}${percent}`}
											geography={geography}
											projection={projection}
											style={{
												default: {
													fill: getColor(geography, percentCountries),
													stroke: 'white',
													strokeWidth: 0.75,
													outline: 'none',
												},
												hover: {
													fill: chroma(getColor(geography, percentCountries)).darken(0.5),
													stroke: 'white',
													strokeWidth: 0.75,
													outline: 'none',
												},
												pressed: {
													fill: '#white',
													stroke: '#white',
													strokeWidth: 0.75,
													outline: 'none',
												}
											}}
										/>
									);
								})}
						</Geographies>
					</ComposableMap>
					<ReactTooltip/>
					<VictoryLegend
						title={formatMessage(messages.title)}
						height={80}
						width={800}
						x={350} y={10}
						centerTitle
						orientation="horizontal"
						gutter={20}
						style={{ title: { fontSize: 16 } }}
						data={[
							{ name: '- 0%', symbol: { fill: '#DCDCDC', type: 'square' } },
							{ name: '- 100%', symbol: { fill: '#000080', type: 'square' } },
						]}
					/>
				</div>
			</Card>
		);
	}
}

export default injectIntl(ResultCountryMap);





// WEBPACK FOOTER //
// ./src/components/ResultCountryMap/ResultCountryMap.js